<template>
  <div class="navbar">
    <div>
      <slot></slot>
    </div>
  </div>
</template>
<script>
/**
   * @describe 底部导航组件
   *
   * @example 详细见tNavitem组件
   *
    <t-navbar>
      <t-navitem :option="{path: 'home' icon: 'home', text: '首页', selected: true }"></t-navitem>
      <t-navitem :option="{path: 'home' icon: 'home', text: '分类', selected: false }"></t-navitem>
      <t-navitem :option="{path: 'home' icon: 'home', text: '购物车', selected: false }"></t-navitem>
      <t-navitem :option="{path: 'home' icon: 'home', text: '我的', selected: false }"></t-navitem>
    </t-navbar>
   */

export default {
  name: 'tNavbar',
  props: {},
  computed: {},
  methods: {},
};

</script>
<style lang="scss">
@import "../style/mixin";

.navbar {
  height: 50px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9;
  text-align: center;
  background-color: #ffffff;
  &>div {
    display: flex;
    @include border-1px-t(#D7D7D7);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/navbar.vue